import React, { useEffect, useState } from 'react';
import styled from "styled-components";
import {Img} from "./Img";

const MyComponent = ({data}) => {

    return (
        <StyledComponent className={'map'}>
            <a target={'_blank'} href={data?.link}>
                <div className={'map__img'}>
                    {/*<Img src={data?.image}/>*/}
                    <iframe src={data?.iframe} width="100%" height="100%" frameBorder="0" loading="lazy"
                            style={{border: "0px"}}></iframe>
                </div>
            </a>

        </StyledComponent>
    );
};
const StyledComponent = styled.section`
    position: relative;

    .map{
    &__img{
      position: relative;
      padding-top: calc(520/1366 * 100%);
        iframe {
            width: 100%;
            height: 100%;
            object-fit: cover;
            position: absolute;
            inset: 0px;
        }
    }
  }
  @media(max-width: 767px){
    .map{
      &__img{
        position: relative;
        padding-top: calc(520/375 * 100%);
      }
    }
  }
`
export default MyComponent;